import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './css/toast.css';
import { INFO_ICON_WHITE } from './paths/defaultImage';
import LazyImage from './component/common/lazyLoad';

/* Toast Messages need to be Refractored & Tested once  */

export const toastError = (content, displayText, position = 'top', setError = undefined) => {
  return (
    <ToastError
      content={content}
      position={position}
      displayText={displayText}
      setError={setError}
    />
  );
};

export const ToastError = ({ content, position, displayText, setError }) => {
  const { t } = useTranslation();

  //* Clear error message after animation ends
  useEffect(() => {
    const toastElem = document.getElementById('toast-message');
    toastElem &&
      toastElem?.addEventListener(
        'animationend',
        function () {
          setError && setError('');
        },
        false
      );
  }, [content]);

  const hideImg = (e) => {
    e.target.style.display = 'none';
  };

  return (
    <div
      id='toast-message'
      className={`toast-message ${position}  ${displayText ? 'text-toast-msg' : ''}`}>
      <div
        className={`message ${!displayText ? 'danger' : ''} d-flex align-items-center gap-2 p-2`}>
        {!displayText && <LazyImage src={INFO_ICON_WHITE} alt='' onError={(e) => hideImg(e)} />}
        {t(content)}
      </div>
    </div>
  );
};
